<template>
    <v-container grid-list-lg id="meal-loading">
        <v-layout column>
            <div xs12 class="headline font-weight-bold my-5">
                Available Recipes for {{ $store.state.plan | capitalize }}
            </div>
            <v-layout row justify-center>
                <div class="hollow-dots-spinner">
                    <div class="dot"></div>
                    <div class="dot"></div>
                    <div class="dot"></div>
                </div>
            </v-layout>
            <div class="mt-2 mb-5 text-xs-center grey--text text--darken-2 subheading font-weight-bold">Loading</div>
        </v-layout>
    </v-container>
</template>

<script>
export default {
    filters: {
        capitalize(word) {
            return word.charAt(0).toUpperCase() + word.slice(1);
        }
    }
};
</script>

<style scoped>
.hollow-dots-spinner, .hollow-dots-spinner * {
    box-sizing: border-box;
}

.hollow-dots-spinner {
    height: 15px;
    width: calc(30px * 3);
}

.hollow-dots-spinner .dot {
    width: 15px;
    height: 15px;
    margin: 0 calc(15px / 2);
    border: calc(15px / 5) solid #616161;
    border-radius: 50%;
    float: left;
    transform: scale(0);
    animation: hollow-dots-spinner-animation 1000ms ease infinite 0ms;
}

.hollow-dots-spinner .dot:nth-child(1) {
    animation-delay: calc(300ms * 1);
}

.hollow-dots-spinner .dot:nth-child(2) {
    animation-delay: calc(300ms * 2);
}

.hollow-dots-spinner .dot:nth-child(3) {
    animation-delay: calc(300ms * 3);

}

@keyframes hollow-dots-spinner-animation {
    50% {
    transform: scale(1);
    opacity: 1;
    }
    100% {
    opacity: 0;
    }
}
</style>
